import jsPDF from "jspdf";
import html2canvas from "html2canvas";

interface AnalyticsPdfOptions {
	element: HTMLElement;
	filename: string;
}

export async function exportAnalyticsPdf({
	element,
	filename,
}: AnalyticsPdfOptions): Promise<void> {
	const canvas = await html2canvas(element, {
		scale: 2,
		backgroundColor: "#ffffff",
		useCORS: true,
		logging: false,
		windowWidth: 1200,
	});

	const pdf = new jsPDF({
		orientation: "portrait",
		unit: "pt",
		format: "a4",
	});

	// A4 = 595.28 x 841.89 pt
	const marginX = 30;
	const marginY = 30;
	const imgWidth = 595.28 - marginX * 2;
	const pageHeight = 841.89 - marginY * 2;

	const scaleFactor = imgWidth / canvas.width;
	const pageCanvasHeight = pageHeight / scaleFactor;

	let renderedHeight = 0;
	let pageNum = 0;

	while (renderedHeight < canvas.height) {
		const sliceHeight = Math.min(
			canvas.height - renderedHeight,
			pageCanvasHeight
		);

		const pageCanvas = document.createElement("canvas");
		pageCanvas.width = canvas.width;
		pageCanvas.height = sliceHeight;

		const ctx = pageCanvas.getContext("2d");
		if (ctx) {
			ctx.drawImage(
				canvas,
				0, renderedHeight, canvas.width, sliceHeight,
				0, 0, canvas.width, sliceHeight
			);
		}

		const pageImgData = pageCanvas.toDataURL("image/png");
		if (pageNum > 0) pdf.addPage();
		pdf.addImage(
			pageImgData, "PNG",
			marginX, marginY,
			imgWidth, sliceHeight * scaleFactor
		);

		// Page number footer
		pdf.setFontSize(8);
		pdf.setTextColor(150);
		pdf.text(`${pageNum + 1}`, 595.28 / 2, 841.89 - 15, { align: "center" });

		renderedHeight += sliceHeight;
		pageNum++;
	}

	pdf.save(filename);
}
